import Link from "next/link";
import { useRouter } from "next/router";
import styles from "./index.module.scss";

export default function Menu() {
  const router = useRouter();

  const links = [
    ["Сотрудничество", "/partners/cooperation"],
    ["Оптовые продажи", "/partners/opt"],
  ];

  return (
    <nav className={styles.Nav}>
      {links.map((link) => (
        <Link key={link[0]} href={link[1]}>
          <a className={router.pathname.includes(link[1]) && styles.Selected}>
            {link[0]}
          </a>
        </Link>
      ))}
    </nav>
  );
}
